import {status as PS} from "./passport";

export const parseIsApprovedText = (status) => {
    const statusesApproved = [PS.expertsApproved, PS.committeeApproved, PS.approved, PS['-approved']];
    const statusesDeclined = [PS.expertsDeclined, PS.committeeDeclined];

    if (statusesApproved.includes(status)) return 'Одобрено';
    if (statusesDeclined.includes(status)) return 'Не одобрено';

    return '';
};

export const MILESTONE_STATUSES_RU = {
    new: {
        key: 'new',
        label: 'Новая',
        bg: 'secondary',
    },
    withoutPublish: {
        key: 'withoutPublish',
        label: 'Заполнена',
        bg: 'primary',
    },
    onApprove: {
        key: 'onApprove',
        label: 'На согласовании',
        bg: 'warning',
    },
    published: {
        key: 'published',
        label: 'Опубликована',
        bg: 'success',
    },
    notApproved: {
        key: 'notApproved',
        label: 'Не согласована',
        bg: 'danger',
    },
    onProjOffice: {
        key: 'onProjOffice',
        label: 'В проектном офисе',
        bg: 'warning',
    },
    inProgress: {
        key: 'inProgress',
        label: 'На исполнении',
        bg: 'secondary',
    },
    approved: {
        key: 'approved',
        label: 'Одобрено',
        bg: 'success',
    },
    declined: {
        key: 'declined',
        label: 'Отклонено',
        bg: 'danger',
    },
    achieved: {
        key: 'achieved',
        label: 'Достигнут',
        bg: 'primary',
    }
}
